export default function setFalsyToNull<T extends Record<string, any>>(
  obj: T,
): T {
  const newObj = { ...obj };

  Object.keys(newObj).forEach((key) => {
    if (!newObj[key] && newObj[key] !== false) {
      // @ts-expect-error-next-line
      newObj[key] = null;
    }
  });

  return newObj;
}
